'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT = exports.INIT = 'query/INIT';
var UPDATE = exports.UPDATE = 'query/UPDATE';

var BATCH_START = exports.BATCH_START = 'query/BATCH_START';
var BATCH_FINISH = exports.BATCH_FINISH = 'query/BATCH_FINISH';

var PERFORM_REQUEST = exports.PERFORM_REQUEST = 'query/PERFORM_REQUEST';
var PERFORM_SUCCESS = exports.PERFORM_SUCCESS = 'query/PERFORM_SUCCESS';
var PERFORM_FAILURE = exports.PERFORM_FAILURE = 'query/PERFORM_FAILURE';

var init = exports.init = function init(payload) {
  return function (dispatch, getState) {
    var _getState = getState(),
        queries = _getState.queries;

    if (Object.keys(queries).length === 0) {
      dispatch({
        type: INIT,
        payload: payload
      });
    }
  };
};

var update = exports.update = function update(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: UPDATE,
    payload: { name: name, params: params }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/actions.js
// module id = 77
// module chunks = 0